import { render, staticRenderFns } from "./LiquidacionesRow.vue?vue&type=template&id=2b3e15e0"
import script from "./LiquidacionesRow.vue?vue&type=script&lang=js"
export * from "./LiquidacionesRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports